import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { createAction, createReducer } from "redux-act";
import { GeometryType } from "@evergis/api";

import { reducerRegistry } from "../reducerRegistry";
import { EditGeometryType } from "../../evergis/core/attributes/geometryTypes";

export const reducerName = "geometryEditor";

export type Positions = Coordinates | Coordinates[] | Coordinates[][];

export enum GeometryEditorMode {
  /** edit geometry mode */
  Edit = "geometryEditMode",
  /** transform geometry mode (changing size, position of whole object) */
  Transform = "geometryTransformMode",
  /** expand geometry mode (changing object to composite object) */
  Expand = "geometryExpandMode",
  Unite = "geometryUniteMode",
  Subtract = "geometrySubtractMode",
}

export interface GeometryEditorState {
  active: boolean;
  geometryType?: GeometryType | EditGeometryType;
  layerName?: string;
  geometry?: Positions;
  mode?: GeometryEditorMode;
}

const initialState: GeometryEditorState = { active: false };

export const reducer = createReducer({}, initialState);
export const setGeometryEditor = createAction<Omit<GeometryEditorState, "active">>(
  "geometryEditor/set-geometry-editor",
);
export const geometryModeSet = createAction<GeometryEditorMode>("geometryEditor/set-geometry-mode");
export const resetGeometryEditor = createAction("geometryEditor/reset-geometry-editor");

reducer.on(setGeometryEditor, (state, { geometry, ...geometryState }) => ({
  ...state,
  ...geometryState,
  active: true,
}));

reducer.on(geometryModeSet, (state, mode) =>
  mode === state.mode
    ? state
    : {
        ...state,
        mode,
      },
);

reducer.on(resetGeometryEditor, () => initialState);

reducerRegistry.register(reducerName, reducer);
